import { createApp } from 'vue'
import ProductChoiceElement from '../vue/ProductChoiceElement.vue'
import ProductCard from '../vue/ProductCard.vue'

import MultiRangeSlider from "multi-range-slider-vue";

import { updateCompare } from '../components/drawer.js';
import { abbrState, toKebabCase } from '../components/utilities.js';

import jmespath from 'jmespath';

import axios from 'axios';
const apiToken = 'nGmnBiyX4x8xrxlTuStYCmrX-bpords1';
const apiUrl = '/api';

const configureApi = (url, token) => {
  return {
    baseURL: url,
    headers: {
      'Authorization': `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest'
    }
  };
};

const axiosReq = axios.create(configureApi(apiUrl, apiToken));

const app = createApp({
  compilerOptions: {
    delimiters: ['[[', ']]']
  },
  components: {
    ProductChoiceElement,
    ProductCard,
    MultiRangeSlider
  },
  data() {
    return {
      search: '',
      sort: 'featured',
      data: [],
      products: [],
      formattedResults: [],
      filteredResults: [],
      choiceData: [],
      stateRegs: [],
      filters: {
        markets: ['*'],
        countries: ['united-states'],
        promotions: ['*'],
        technologies: ['*'],
        categories: ['*'],
        producttypes: ['*'],
        nitrogensource: ['*'],
        activeingredient: ['*'],
        activeingredientpercentage: ['*'],
        areasofuse: ['*'],
        sgnsize: ['*'],
        statesregistered: ['*'],
        nitrogenrangehigh: 50,
        nitrogenrangelow: 0,
        slowreleasenrangehigh: 100,
        slowreleasenrangelow: 0,
      },
      nitrogensliderminvalue: 0,
      nitrogenslidermaxvalue: 50,
      slowreleasensliderminvalue: 0,
      slowreleasenslidermaxvalue: 100,
      highestpossiblenitrogen: 50,
      lowestpossiblenitrogen: 0,
    }
  },
  computed: {
  },
  methods: {
    handleRemoveItem(object) {
      
      if (this.filters[object.group].includes(object.value)) {
        // remove the value from the array
        this.filters[object.group] = this.filters[object.group].filter(item => item !== object.value);

        if (object.group == 'countries') {
          this.filterProducts();
          this.buildChoiceData();
        }

      }

      // save the filtered results to a session storage
      sessionStorage.filters = JSON.stringify(this.filters);

    },
    handleAddItem(object) {

      if (!this.filters[object.group].includes(object.value)) {
        this.filters[object.group].push(object.value);
      }

      this.filterProducts();
      // TODO: this is where we can do something about multi select ??
      if (object.group !== 'countries') {
        this.buildChoiceData();
      }

      // turn off all of the compare buttons, vue will light them up again
      const compareButtons = document.querySelectorAll('.compare');
      for (let i = 0; i < compareButtons.length; i++) {
        // remove added-to-compare class
        compareButtons[i].classList.remove('added-to-compare');

      };

      // save the filtered results to a session storage
      sessionStorage.filters = JSON.stringify(this.filters);

    },
    filterProducts() {

      let filters = this.filters;

      this.filteredResults = this.formattedResults.filter(product => {

          const filterByProperty = (productProperty, filterProperty) => {
            if (filterProperty.length > 0 && filterProperty[0] !== '*') {
              if (productProperty) {
                return filterProperty.some(fp => productProperty.includes(fp));
              } else {
                return false;
              }
            }
            return true;
          };

          const searchWords = this.search ? [this.search.toLowerCase()] : [];

          const productTitle = product.title.toLowerCase()
          // remove circle R
          .replace(/®/g, '')
          // remove TM
          .replace(/™/g, '')
          
          let match = searchWords.length === 0 || searchWords.some(word =>
            productTitle.includes(word) ||
            product.productCode.toLowerCase().includes(word)
          );
          

          if (!match) return false;

          match = match && filterByProperty(product.markets.map(m => m.slug), filters.markets);
          match = match && filterByProperty(product.country ? product.country.map(c => c.slug) : null, filters.countries);
          match = match && filterByProperty(product.technologies.map(t => t.slug), filters.technologies);
          match = match && filterByProperty(product.categories.map(c => c.slug), filters.categories);
          match = match && filterByProperty(product.productType.map(p => p.slug), filters.producttypes);
          // match = match && filterByProperty(product.nitrogenSource ? product.nitrogenSource.split(',').map(s => toKebabCase(s)) : null, filters.nitrogensource);
          match = match && filterByProperty(product.nitrogenSources.map(s => s.slug), filters.nitrogensource);
          match = match && filterByProperty(product.activeIngredients.map(a => a.compound[0].title), filters.activeingredient);
          match = match && filterByProperty(product.activeIngredients.map(a => a.percentage), filters.activeingredientpercentage);
          match = match && filterByProperty(product.areasOfUse.map(a => a.slug), filters.areasofuse);
          match = match && filterByProperty(product.sgnSize, filters.sgnsize);
          match = match && filterByProperty(product.registrations, filters.statesregistered);


          if (product.nitrogen !== null) {
            if (filters.nitrogenrangehigh && filters.nitrogenrangehigh !== 100) {
              match = match && (product.nitrogen <= filters.nitrogenrangehigh);
            }
            if (filters.nitrogenrangelow && filters.nitrogenrangelow !== 0) {
              match = match && (product.nitrogen >= filters.nitrogenrangelow);
            }
          }

          if (product.slowReleaseN !== null) {
            if (filters.slowreleasenrangehigh && filters.slowreleasenrangehigh !== 100) {
              match = match && (product.slowReleaseN <= filters.slowreleasenrangehigh);
            }
            if (filters.slowreleasenrangelow && filters.slowreleasenrangelow !== 0) {
              match = match && (product.slowReleaseN >= filters.slowreleasenrangelow);
            }
          }

          // match promotions
          if (filters.promotions.includes('featured')) {
            match = match && product.featured;
          }

          if (filters.promotions.includes('discontinued')) {
            match = match && product.discontinued;
          }

          if (filters.promotions.includes('aRewards')) {
            match = match && product.aRewards;
          }

          return match;
      });

      // sort
      if ( this.sort === 'name' || this.sort === 'featured') {

        this.filteredResults.sort((a, b) => {
          return a.title > b.title ? 1 : -1;
        });

        if ( this.sort === 'featured' ) {

          // put the featured articles at the top
          this.filteredResults.sort((a, b) => {
            return a.featured < b.featured ? 1 : -1;
          });
  
        }

      }

      // save the filters to a session storage
      sessionStorage.filters = JSON.stringify(this.filters);
      // save the quicksearch query to a session storage
      sessionStorage.search = this.search;
  
    },
    buildChoiceData() {

        let countries = [];

        function createInitialArray() {
          return [{ label: 'All', value: '*' }];
        }
        
        let markets = createInitialArray();
        let promotions = createInitialArray();
        let technologies = createInitialArray();
        let categories = createInitialArray();
        let productTypes = createInitialArray();
        let nitrogenSource = createInitialArray();
        let activeIngredient = createInitialArray();
        let activeIngredientPercentage = createInitialArray();
        let areasOfUse = createInitialArray();
        let sgnSize = createInitialArray();
        let registrations = createInitialArray();

        this.filteredResults.forEach(product => {

          //////////// Relationships (entries) all look like this

          function addUniqueItems(items, targetArray) {
            if (items) {
              items.forEach(item => {
                if (!targetArray.some(c => c.value === item.slug)) {
                  let temp = {
                    label: item.title,
                    value: item.slug
                  }
                  targetArray.push(temp);
                }
              });
            }
          }
          
          // countries
          addUniqueItems(product.markets, markets);
          
          // countries
          addUniqueItems(product.country, countries);
          
          // technologies
          addUniqueItems(product.technologies, technologies);
          
          // categories
          addUniqueItems(product.categories, categories);
          
          // product types
          addUniqueItems(product.productType, productTypes);

          // areas of use
          addUniqueItems(product.areasOfUse, areasOfUse);

          //////////// end relationships ////////////////////////////////

          // nitrogen source
          // this is a comma delimited string
          // if ( product.nitrogenSource && product.nitrogenSource.length > 0) {
          //   let sources = product.nitrogenSource.split(',');
          //   sources.forEach(source => {
          //     if (!nitrogenSource.some(c => c.label === source)) {
          //       let temp = {
          //         label: source,
          //         value: toKebabCase(source)
          //       }
          //       nitrogenSource.push(temp);
          //     }
          //   });
          // }

          if (product.nitrogenSources) {
            product.nitrogenSources.forEach(source => {
              if (!nitrogenSource.some(c => c.label === source.title)) {
                let temp = {
                  label: source.title,
                  value: source.slug
                }
                nitrogenSource.push(temp);
              }
            });
          }

          // sgn size
          if ( product.sgnSize && product.sgnSize.length > 0) {
            // get rid of any whitespace in the string
            product.sgnSize = product.sgnSize.replace(/\s/g, '');
            // only numbers please
            if (!isNaN(product.sgnSize)) {
              if (!sgnSize.some(c => c.value === product.sgnSize)) {
                let temp = {
                  label: product.sgnSize,
                  value: product.sgnSize
                }
                sgnSize.push(temp);
              }
            }
          }

          // active ingredient
          // this is a comma delimited string
          // if ( product.activeIngredient && 
          //       product.activeIngredient.length > 0 && 
          //       product.activeIngredient !== 'N/A' && 
          //       product.activeIngredient !== ' ' ) {
          //   let ingredients = product.activeIngredient.split(',');
          //   ingredients.forEach(ingredient => {
          //     if (!activeIngredient.some(c => c.label === ingredient)) {
          //       if ( ingredient && ingredient.length > 0 && ingredient !== 'N/A' && ingredient !== ' ') {
          //         let temp = {
          //           label: ingredient,
          //           value: ingredient
          //         }
          //         activeIngredient.push(temp);
          //       }
          //     }
          //   });
          // }

          if (product.activeIngredients) {
            product.activeIngredients.forEach(ingredient => {
              if (!activeIngredient.some(c => c.label === ingredient.compound[0].title)) {
                let temp = {
                  label: ingredient.compound[0].title,
                  value: ingredient.compound[0].title
                }
                activeIngredient.push(temp);
              }
            });
          }

          // buuld the percentages based on the currently selected compound

          if (product.activeIngredients) {
            product.activeIngredients.forEach(ingredient => {
              if (!activeIngredientPercentage.some(c => c.label === ingredient.percentage) && ingredient.compound[0].title === this.filters.activeingredient[0]) {
                let temp = {
                  label: ingredient.percentage,
                  value: ingredient.percentage
                }
                activeIngredientPercentage.push(temp);
              }
            }
            );
          }

          // registrations
          if ( product.registrations && product.registrations.length > 0) {
            product.registrations.forEach(reg => {
              if (!registrations.some(c => c.value === reg)) {
                let temp = {
                  label: abbrState(reg, 'name'),
                  value: reg
                }
                registrations.push(temp);
              }
            });
          }
  
          // promotions, but we need to check Featured, Discontinued, and A-Rewards
          if (product.featured && !promotions.some(c => c.value === 'featured' ) ){
            let temp = {
              label: 'Featured',
              value: 'featured'
            }
            promotions.push(temp);
          }
  
          if (product.discontinued && !promotions.some(c => c.value === 'discontinued' ) ) {
            let temp = {
              label: 'While Supplies Last',
              value: 'discontinued'
            }
            promotions.push(temp);
          }
  
          if (product.aRewards && !promotions.some(c => c.value === 'aRewards' ) ) {
            let temp = {
              label: 'A+ Rewards',
              value: 'aRewards'
            }
            promotions.push(temp);
          }
          
        });

        // sort the arrays not including the 'All' option

        function sortArray(array) {
          array.sort((a, b) => {
            if (a.label === 'All') return -1;
            if (b.label === 'All') return 1;
            return a.label > b.label ? 1 : -1;
          });
        }
        
        sortArray(registrations);
        sortArray(technologies);
        sortArray(categories);
        sortArray(productTypes);
        sortArray(nitrogenSource);
        sortArray(activeIngredient);
        sortArray(activeIngredientPercentage);
        sortArray(areasOfUse);

        // in the categories array, move Fertilizers to second position
        categories.sort((a, b) => {
          if (a.label === 'All') return -1;
          if (b.label === 'All') return 1;
          if (a.label === 'Fertilizers') return -1;
          if (b.label === 'Fertilizers') return 1;
          return a.label > b.label ? 1 : -1;
        });

        

        // because numbers
        sgnSize.sort((a, b) => {
          if (a.label === 'All') return -1;
          if (b.label === 'All') return 1;
          // make a and b numbers
          a = parseInt(a.label);
          b = parseInt(b.label);
          return a > b ? 1 : -1;
        });

        // because fixed order
        // golf, sports fields, lawn and landscape, horticulture
        const order = ['Golf', 'Sports Fields', 'Lawn & Landscape', 'Horticulture'];

        markets.sort((a, b) => {

          if (a.label === 'All') return -1;
          if (b.label === 'All') return 1;

          let indexA = order.indexOf(a.label);
          let indexB = order.indexOf(b.label);

          if (indexA === -1) indexA = Infinity; // If a.label is not in the order array, move it to the end
          if (indexB === -1) indexB = Infinity; // If b.label is not in the order array, move it to the end

          return indexA - indexB;
        });

        // done sorting. build the array
   
        this.choiceData  = {
          countries: {
            title: 'Countries',
            choices: countries
          },
          markets: {
            title: 'Markets',
            choices: markets,
          },
          promotions: {
            title: 'Promotions',
            choices: promotions,
          },
          technologies: {
            title: 'Technologies',
            choices: technologies,
          },
          categories: {
            title: 'Categories',
            choices: categories,
          },
          producttypes: {
            title: 'Product Types',
            choices: productTypes,
          },
          nitrogensource: {
            title: 'Nitrogen Source',
            choices: nitrogenSource,
          },
          activeingredient: {
            title: 'Active Ingredient',
            choices: activeIngredient,
          },
          activeingredientpercentage: {
            title: 'Active Ingredient (%)',
            choices: activeIngredientPercentage,
          },
          areasofuse: {
            title: 'Areas of Use',
            choices: areasOfUse,
          },
          sgnsize: {
            title: 'SGN Size',
            choices: sgnSize,
          },
          statesregistered: {
            title: 'States Registered',
            choices: registrations,
          }
        }

        this.nitrogenslidermaxvalue = this.filters.nitrogenrangehigh;
        this.nitrogensliderminvalue = this.filters.nitrogenrangelow;

        this.slowreleasenslidermaxvalue = this.filters.slowreleasenrangehigh;
        this.slowreleasensliderminvalue = this.filters.slowreleasenrangelow;
  
    },
    formatProducts() {

      this.formattedResults = this.products.map(product => {

        let states = jmespath.search(this.stateRegs, "[?\"Part Code\" == '0000000000"+product.productCode+"'].State");
        // make unique and sort
        states = [...new Set(states)]; 
        states.sort();

        let activeIngredientsString = '';
        if (product.activeIngredients) {
          product.activeIngredients.forEach(ingredient => {
            activeIngredientsString += `${ingredient.compound[0].title} ${ingredient.percentage}%, `;
          } );
          // trim the delimiter
          activeIngredientsString = activeIngredientsString.slice(0, -2);
        }
        
        let activeIngredientsStringSoft = '';
        if (product.activeIngredients) {
          product.activeIngredients.forEach(ingredient => {
            activeIngredientsStringSoft += `${ingredient.compound[0].title} ${ingredient.percentage}%<br/> `;
          } );
          // trim the delimiter
          activeIngredientsStringSoft = activeIngredientsStringSoft.slice(0, -6);
        }

        let nitrogenSourcesString = '';
        if(product.nitrogenSource) {
        product.nitrogenSources.forEach(source => {
          nitrogenSourcesString += `${source.title}, `;
        } );
        // trim the delimiter
        nitrogenSourcesString = nitrogenSourcesString.slice(0, -2);
        }
        

        let categoryString = '';
        if (product.categories) {
        product.categories.forEach(category => {
          categoryString += `${category.title}, `;
        } );
        // trim the delimiter
        categoryString = categoryString.slice(0, -2);
        }

        let categoryStringSoft = '';
        if (product.categories) {
        product.categories.forEach(category => {
          categoryStringSoft += `${category.title}<br/> `;
        } );
        // trim the delimiter
        categoryStringSoft = categoryStringSoft.slice(0, -6);
        }
        
        // 'international'
        let intl = false;
        let can = false;
        let usa = false;

        if ( product.country ) {
          let countrySlugs = product.country.map(country => country.slug);
          if (countrySlugs.includes('world')) {
            intl = true;
          }

          if (countrySlugs.includes('canada')) {
            can = true;
          }

          if (countrySlugs.includes('united-states')) {
            usa = true;
          }
        }

        // packaging
        let packaging = '';
        if ( product.packaging ) {
          if ( can || intl ) {
              // convert to kilograms
              let pounds = product.packaging
              // convert pounds to a Number
              pounds = Number(pounds);
              let kilograms = pounds * 0.453592;
              packaging = Number(kilograms).toFixed(2) + ' kgs';
          } else {
            packaging = product.packaging + ' lbs';
          }
        } else {
          packaging = 'N/A';
        }

        // is this added to compare list?
        let compareList = JSON.parse(sessionStorage.compareList);
        let addedToCompare = false;
        if ( compareList.indexOf( product.id ) > -1 ) {
          addedToCompare = true;
        }

        // this is the new record. that gets filtered.

        return {
          id: product.id,
          title: product.title,
          productCode: product.productCode,
          registrations: states,
          markets: product.markets,
          country: product.country,
          technologies: product.technologies,
          areasOfUse: product.areasOfUse,
          categories: product.categories,
          productType: product.productType,
          intl: intl,
          can: can,
          usa: usa,
          featured: product.featured,
          discontinued: product.discontinued,
          nitrogen: product.nitrogen,
          aRewards: product.aRewards,
          packaging: packaging,
          categoryString: categoryString,
          categoryStringSoft: categoryStringSoft,
          url: product.url,
          sgnSize: product.sgnSize,
          transformedBagUrlSmall: product.transformedBagUrlSmall,
          transformedBagUrlLarge: product.transformedBagUrlLarge,
          country: product.country,
          nitrogenSource: product.nitrogenSource,
          nitrogenSources: product.nitrogenSources,
          nitrogenSourcesString: nitrogenSourcesString,
          addedToCompare: addedToCompare,
          description: product.description,
          bullets: product.bullets,
          slowReleaseN: product.slowReleaseN,
          activeIngredientsString: activeIngredientsString,
          activeIngredientsStringSoft: activeIngredientsStringSoft,
          activeIngredients: product.activeIngredients,
        }

      });

    },
    sortProducts(e) {

      this.sort = e.target.id;

      // toggle the active class
      const sortButtons = document.querySelectorAll('.sort');
      for (let i = 0; i < sortButtons.length; i++) {
        sortButtons[i].classList.remove('active');
      };
      e.target.classList.add('active');

      this.filterProducts();
      this.buildChoiceData();

    },
    clearFilters() {

      this.filters = {
        markets: ['*'],
        countries: [],
        promotions: ['*'],
        technologies: ['*'],
        categories: ['*'],
        producttypes: ['*'],
        nitrogensource: ['*'],
        activeingredient: ['*'],
        activeingredientpercentage: ['*'],
        areasofuse: ['*'],
        sgnsize: ['*'],
        statesregistered: ['*'],
        nitrogenrangehigh: 100,
        nitrogenrangelow: 0,
        slowreleasenrangehigh: 100,
        slowreleasenrangelow: 0,
      }

      this.search = '';

      this.filterProducts();
      this.buildChoiceData();
      
      // this is how choices sets a choice
      const selectInputs = document.querySelectorAll('.choices');
      for (let i = 0; i < selectInputs.length; i++) {

        const choiceItems = selectInputs[i].querySelectorAll(".choices__item--selectable");
        for (let i = 0; i < choiceItems.length; i++) {
            if (choiceItems[i].dataset.value === '*' || choiceItems[i].dataset.value === '0' || choiceItems[i].dataset.value === '100') {
                choiceItems[i].dispatchEvent(new Event('mousedown'));
            }
        }

      };

      // clear the search box
      const searchInput = document.querySelector('.quicksearch');
      searchInput.value = '';

      // clear any choice data-type select multiple
      // const multiSelects = document.querySelectorAll('.choices[data-type="select-multiple"]');
      // for (let i = 0; i < multiSelects.length; i++) {
      //   multiSelects[i].querySelector('.choices__list').innerHTML = '';
      // }

      // clear the filters from session storage
      sessionStorage.removeItem('filters');

    },
    quicksearch() {
      this.filterProducts();
      this.buildChoiceData();
    },
    clearsearch() {
      this.search = '';
      this.filterProducts();
      this.buildChoiceData();
    },
    updateNitrogenValues(e) {

      this.filters.nitrogenrangehigh = e.maxValue;
      this.filters.nitrogenrangelow = e.minValue;
      
      this.filterProducts();
      this.buildChoiceData();
    },
    updateSlowReleaseNValues(e) {

      this.filters.slowreleasenrangehigh = e.maxValue;
      this.filters.slowreleasenrangelow = e.minValue;
      
      this.filterProducts();
      this.buildChoiceData();
    },
  },
  async created() {

    // if feed data is not in session storge, get it
    if (!sessionStorage.feed) {
      const feed = await axios.get('https://pndata.andersonsinc.com/misc/StateRegistrations');
      sessionStorage.feed = JSON.stringify(feed.data.StateRegistrations);
      this.stateRegs = feed.data.StateRegistrations;
    } else {
      this.stateRegs = JSON.parse(sessionStorage.feed);
    }

     // Fetch some graphQL data
     const searchQuery = `
     query MyQuery {
      entries(section: "products", limit: null, orderBy: "dateCreated DESC") {
        dateCreated @formatDateTime(format: "Y-m-d")
        title
        ...on products_default_Entry {
          id
          title
          productCode
          featured
          discontinued
          aRewards
          nitrogen
          slowReleaseN
          sgnSize
          packaging
          url
          nitrogenSources {
            ... on nitrogenSources_default_Entry {
              title
              slug
            }
          }
          activeIngredients {
           ...on activeIngredients_BlockType {
             compound {
               ...on activeIngredients_default_Entry {
                 title
               }
             }
             percentage
           }
         }
          description
          bullets
          transformedBagUrlSmall
          transformedBagUrlLarge
          markets {
            ... on markets_default_Entry {
              title
              slug
            }
          }
          country {
            ... on countries_default_Entry {
              title
              slug
            }
          }
          technologies {
            ... on technologies_default_Entry {
              title
              slug
            }
          }
          areasOfUse {
            ... on areasOfUse_default_Entry {
              title
              slug
            }
          }
          categories {
            ... on productCategories_default_Entry {
              title
              slug
            }
          }
          productType {
            ... on productTypes_default_Entry {
              title
              slug
            }
          }
        }
      }
    }
    `;

    const response = axiosReq.post('', {
      query: searchQuery
    }).then((response) => {
      
      this.products = response.data.data.entries;

      if (sessionStorage.filters) {
        // if the filters are in session storage, use them! (aka history)
        this.filters = JSON.parse(sessionStorage.filters);
      }

      if (sessionStorage.search) {
        // if the search is in session storage, use it! (aka history)
        this.search = sessionStorage.search;
      }

      // one time
      this.formatProducts();

      // find nitrogen range (also one time)
      let high = 0;
      let low = 10000000;

      this.products.map(product => {

        //nitrogen range setup
        let nitrogen = product.nitrogen;
        if (nitrogen) {
          nitrogen = Number(nitrogen);
          if (nitrogen > high) high = nitrogen;
          if (nitrogen < low) low = nitrogen;
        }

      });

      this.highestpossiblenitrogen = high;
      this.nitrogenslidermaxvalue = high;
      this.lowestpossiblenitrogen = low;

      // every time
      this.filterProducts();     
      this.buildChoiceData(); 
      
      //let's go
      // unhide the #products-opt element
      document.getElementById('products-opt').classList.remove('hidden');
      // hide the loader
      document.getElementById('loader').classList.add('hidden');

    }).catch((error) => {
      console.log(error);
    });

    
  },
  async mounted() {


    var compareList

    // compare list is not stored. do something!
    if (!sessionStorage.compareList) {
      compareList = JSON.stringify([])
      sessionStorage.compareList = compareList;
    } else {
      compareList = JSON.parse(sessionStorage.compareList);
    }
    
    var data = {
      compareList: compareList
    };
    
    var tokenName = window.csrfTokenName;
    data[ tokenName ] = window.csrfTokenValue;
    
    $.ajax( {
      type: "post",
      data: data,
      url: '/actions/_mad-utilities/mad/do-something',
      success: function ( response ) {
        // console.log( response );
        updateCompare(response);
      },
      error: function(e){
        console.log("ERROR");
        console.log(e);
      }
    });


    //// figure out another way to do this?
    //////////////////////////////////////
    // Function to add the "list" class to all elements with the class "item"
    function addListClassToItems() {
      var items = document.querySelectorAll('.item, .grid');

      if (items) {
        items.forEach(function (item) {
          item.classList.add('list');
        });
      }

    }

    // Function to remove the "list" class from all elements with the class "item"
    function removeListClassFromItems() {
      var items = document.querySelectorAll('.item, .grid');

      if (items) {
        items.forEach(function (item) {
          item.classList.remove('list');
        });
      }
    }

    // Add click event listeners to the buttons
    var listButton = document.getElementById('list-format');
    var gridButton = document.getElementById('grid-format');

    if (listButton) {
      listButton.addEventListener('click', addListClassToItems);
    }

    if (gridButton) {
      gridButton.addEventListener('click', removeListClassFromItems);
    }

    // get the URL params
    const urlParams = new URLSearchParams(window.location.search);

    // if there are any paramas at all, reset all filtersand clear storage and search
    if (window.location.search) {
      console.log('there are params, filters clearing');
      this.clearFilters();
      this.search = '';
      sessionStorage.removeItem('filters');
      sessionStorage.removeItem('search');
      // populate the filters array based on the search params
      urlParams.forEach((value, key) => {
        if (key !== 'q') {
          this.filters[key] = value.split(',');
        }
      });
      console.log('filters set');
      // this.filterProducts();
      // this.buildChoiceData();

    }

    if (urlParams.has('q')) {
      // get the search parama
      const search = urlParams.get('q');
      if (search) {
        const element = document.querySelector('.quicksearch');
        element.value = search;
        this.search = search;
      }
    }


  }
});

app.mount('#products-opt')